export default __webpack_public_path__ + "static/service-header-image-20149cf583a4bc6011142606b42ee62a.png";